import { combineReducers } from '@reduxjs/toolkit';

import byId from './byId';

/**
 * @typedef {{
 *  byId: import('./byId').ByIdState,
 * }} DataState
 */

export default combineReducers({
  byId,
});
